// Contas da carga (as mesmas que o banco faz) e o agenciamento sugerido pela
// regra de quem agenciou.
const centavos = (v) => Math.round((Number(v) || 0) * 100);

// líquido = frete − pedágio embutido − INSS − SEST/SENAT − IR − outros
export function liquidoDoFrete(f) {
  return (centavos(f.valor_frete) - centavos(f.pedagio_valor) - centavos(f.desc_inss)
    - centavos(f.desc_sest_senat) - centavos(f.desc_irrf) - centavos(f.desc_outros)) / 100;
}

// saldo a receber = líquido + estadia − adiantamento
export function saldoDoFrete(f) {
  return (centavos(liquidoDoFrete(f)) + centavos(f.estadia_valor) - centavos(f.adto_valor)) / 100;
}

// A carga com o líquido e o saldo preenchidos (o aparelho mostra antes de o
// servidor calcular; eles nunca são enviados).
export function comContas(f) {
  return { ...f, valor_liquido: liquidoDoFrete(f), saldo_valor: saldoDoFrete(f) };
}

function valendo(regra, dia) {
  return !regra.deleted_at && regra.vigente_de <= dia && (!regra.vigente_ate || regra.vigente_ate >= dia);
}

// Regra de agenciamento do colaborador nesse dia: a do caminhão, se houver;
// senão, a geral dele.
export function regraDeAgenciamento(regras, colaboradorId, dia, veiculoId = null) {
  const dele = regras.filter((r) => r.componente === 'agenciamento' && r.colaborador_id === colaboradorId && valendo(r, dia));
  return dele.find((r) => veiculoId && r.veiculo_id === veiculoId) ?? dele.find((r) => !r.veiculo_id) ?? null;
}

// Valor sugerido: o da regra; com faixa, "valor" até o limite (inclusive) e
// "valor_acima" depois dele, olhando o frete bruto ou o líquido.
export function agenciamentoSugerido(regra, frete) {
  if (!regra) return null;
  if (regra.faixa_ate === null || regra.faixa_ate === undefined) return Number(regra.valor);
  const base = regra.base === 'liquido' ? liquidoDoFrete(frete) : Number(frete.valor_frete) || 0;
  return base > Number(regra.faixa_ate) ? Number(regra.valor_acima) : Number(regra.valor);
}

// Totais de uma viagem para o resumo.
export function totaisDaViagem(fretes, vales) {
  const soma = (lista, campo) => lista.reduce((s, x) => s + centavos(x[campo]), 0) / 100;
  const cargas = fretes.map(comContas);
  return {
    cargas: cargas.length,
    bruto: soma(cargas, 'valor_frete'),
    liquido: soma(cargas, 'valor_liquido'),
    adiantamentos: soma(cargas, 'adto_valor'),
    aReceber: soma(cargas.filter((f) => !f.saldo_recebido_em), 'saldo_valor'),
    vales: soma(vales, 'valor'),
  };
}
